export default __webpack_public_path__ + "static/media/QH.f56614ef.svg";